module.exports = __webpack_public_path__ + "static/media/aircon-dark.3dca2056.svg";